// eslint-disable-next-line no-shadow
export enum Modals {
  init = '',
  ApprovePending = 'ApprovePending',
  ApproveRejected = 'ApproveRejected',
  SendPending = 'SendPending',
  SendPendingSimple = 'SendPendingSimple',
  SendRejected = 'SendRejected',
  SendSuccess = 'SendSuccess',
}

export interface ModalState {
  activeModal: Modals;
  txHash: string;
  open: boolean;
  repeatHandler?: () => void;
}

export type ModalsInitialState = {
  modalState: ModalState;
};
